export default "__VITE_ASSET__CrKlIBjL__"